import { Box, Button, TextField, Typography } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { useDataProvider, useRefresh } from 'react-admin';
import { User } from '../../types/user';
import "./index.css"

interface Props {
    closeModal: () => void;
    openCreate: (add: boolean, create: boolean) => void;
    id: string;
}

interface State {
    email: string;
    selectedUser: undefined | User;
    users: Array<User>;
    page: number;
    total: number;
    isFetched: boolean
}

const AddReferral: FC<Props> = ({ closeModal, id, openCreate }) => {
    const dataProvider = useDataProvider()
    const refresh = useRefresh()
    const [state, setState] = useState<State>({
        email: '',
        selectedUser: undefined,
        users: Array<User>(),
        page: 1,
        total: 0,
        isFetched: false
    })
    const [email, setEmail] = useState('')

    const handleSearch = async (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.currentTarget.value)
        if (e.currentTarget.value.length > 3) {
            const users = await getUsers(1, e.currentTarget.value)
            setState({ ...state, users: users.data, page: 1, total: users.total })
        } else {
            setState({ ...state, users: Array<User>(), page: 1 })
        }
    }

    const saveReferral = async () => {
        if (state.selectedUser) {
            let user = state.selectedUser
            user.isNewReferral = true
            user.referredBy = id
            const result = await dataProvider.update('users/cms', {
                data: user,
                id: user.id,
                previousData: {} as User
            })
            if (result.data.referredBy) {
                refresh()
            }
        }
    }

    const getUsers = async (page: number, email: string) => {
        const users = await dataProvider.getList('users', {
            filter: {
                blocked: "all",
                searchName: '',
                searchSurname: '',
                searchEmail: email,
                searchPhone: '',
                referral: id
            },
            pagination: { page: page, perPage: 100 },
            sort: { field: "_id", order: "asc" }
        }
        ) as any
        return users
    }

    const handleScroll = async (event: React.UIEvent<HTMLDivElement, UIEvent>) => {
        const top = event.currentTarget.scrollTop;
        const height = event.currentTarget.scrollHeight
        if (height - top < 600 && state.users.length < state.total) {
            const page = state.page + 1
            let fetchedUsers = state.users
            const users = await getUsers(page, email)
            fetchedUsers = fetchedUsers.concat(users.data)
            setState({ ...state, users: fetchedUsers, page: page })
        }
    }

    const handleSelect = (user: User) => {
        setState({ ...state, selectedUser: user, users: Array<User>() })
    }

    const toCreate = () => {
        closeModal()
        openCreate(false,true)
    }

    return (
        <>
            <Box>
                <Box display="flex" justifyContent="center">
                    <Typography variant="h6" className="base-color">
                        Add new Referral
                   </Typography>
                </Box>
                <Box display="flex" alignItems="center" justifyContent="center" padding="4em">
                    {!state.selectedUser ? <Box>
                        <TextField
                            type="text"
                            label=""
                            className="search-email-field"
                            value={email}
                            placeholder="search by email"
                            onChange={handleSearch}
                            defaultValue={1}
                            required
                        />
                        <div className={state.users.length > 0 ? "email-dropdown" : "opacity-zero"}>
                            <div className="filter-container" onScroll={handleScroll}>
                                {state.users.map((item) => {
                                    return (
                                        <div className="filter-item">
                                            <div className="category-title email-item" onClick={() => handleSelect(item)}>
                                                {item.email}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </Box> :
                        <Box className="base-color border-referral" marginRight="2em" >
                            <Box display="flex" justifyContent="space-between">
                                <Typography className="base-color">
                                    name:
                                </Typography>
                                <Typography className="base-color">
                                    {state.selectedUser.name}
                                </Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between">
                                <Typography className="base-color">
                                    surname:
                                </Typography>
                                <Typography className="base-color">
                                    {state.selectedUser.surname}
                                </Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between">
                                <Typography className="base-color">
                                    email:
                                </Typography>
                                <Typography className="base-color">
                                    {state.selectedUser.email}
                                </Typography>
                            </Box>
                        </Box>
                    }
                    <Typography className="base-color">
                        or
                    </Typography>
                    <Button className="user-cancel-button user-modal-buttons" onClick={toCreate}>Add New</Button>
                </Box>
                <Box display="flex" justifyContent="space-evenly" paddingTop="1em" >
                    <Button className="user-cancel-button user-modal-buttons" disabled={!state.selectedUser} onClick={saveReferral}>Save</Button>
                    <Button className="user-cancel-button user-modal-buttons" onClick={closeModal}>Cancel</Button>
                </Box>
            </Box>
        </>
    )
}

export default AddReferral